<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Personologica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiPersonologica.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiPersonologica.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>

                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataAnamnesiPersonologica.id" @click="onSaveAnamnesiPersonologica"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiPersonologica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiPersonologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiPersonologica: "/rsaschedarelazionesanitariaanamnesipersonologica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiPersonologica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiPersonologica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiPersonologicaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPersonologicaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiPersonologica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPersonologicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiPersonologica = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSaveAnamnesiPersonologica() {
            let me = this;
            me.jsonDataAnamnesiPersonologica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiPersonologica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiPersonologica, me.jsonDataAnamnesiPersonologica, me.saveSchedaRelazioneSanitariaAnamnesiPersonologicaSuccessResponse, me.saveSchedaRelazioneSanitariaPersonologicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiPersonologicaSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Anamnesi personologica salvata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaAnamnesiPersonologicaErrorResponse() {
            console.error("Errore nel salvataggio dell'anamnesi personologica:");
        },
    },
};
</script>
